/**
 * Masters module constants — separated to avoid circular imports with actions.
 */
import type { MasterEntry } from './registry.js'

/** Minimal master types seeded on fresh install */
export const DEFAULT_MASTER_TYPES = ['languages', 'timezones'] as const

/** Predefined master data loaders (lazy-loaded on seed) */
export const PREDEFINED_MASTERS: Record<string, () => Promise<MasterEntry[]>> = {
  currencies: () => import('./data/currencies.json', { with: { type: 'json' } }).then(m => m.default),
  languages: () => import('./data/languages.json', { with: { type: 'json' } }).then(m => m.default),
  timezones: () => import('./data/timezones.json', { with: { type: 'json' } }).then(m => m.default),
  'social-networks': () => import('./data/social-networks.json', { with: { type: 'json' } }).then(m => m.default),
  genders: () => import('./data/genders.json', { with: { type: 'json' } }).then(m => m.default),
  'marital-statuses': () => import('./data/marital-statuses.json', { with: { type: 'json' } }).then(m => m.default),
  'education-levels': () => import('./data/education-levels.json', { with: { type: 'json' } }).then(m => m.default),
  industries: () => import('./data/industries.json', { with: { type: 'json' } }).then(m => m.default),
  'company-types': () => import('./data/company-types.json', { with: { type: 'json' } }).then(m => m.default),
  units: () => import('./data/units.json', { with: { type: 'json' } }).then(m => m.default),
  countries: () => import('./data/countries.json', { with: { type: 'json' } }).then(m => m.default),
  'product-categories': () => import('./data/product-categories.json', { with: { type: 'json' } }).then(m => m.default),
  'phone-prefixes': () => import('./data/phone-prefixes.json', { with: { type: 'json' } }).then(m => m.default),
  'document-types': () => import('./data/document-types.json', { with: { type: 'json' } }).then(m => m.default),
}
